import React from 'react'
import { Layout, Menu, Divider, Typography, Avatar } from 'antd'
import { NavLink, useLocation } from 'react-router-dom'

import {
  UserOutlined,
  CalendarOutlined,
  DashboardOutlined,
  CrownOutlined,
  HddOutlined,
  BookOutlined,
  TeamOutlined,
  FileTextOutlined,
  StarOutlined
} from '@ant-design/icons'

import { AiFillCustomerService } from 'react-icons/ai'
import Logo from '../Logo'
import { RiArticleLine } from 'react-icons/ri'
import { ImBooks, ImUsers } from 'react-icons/im'

const { Sider } = Layout
const { Text } = Typography

const SideNav = (props) => {
  const { collapsed, onCollapse } = props
  let currentPath = useLocation().pathname

  // Fix for side nav highlight
  if (currentPath.includes('/app/course/'))
    currentPath = currentPath.replace('/app/course/', '/app/courses/')

  const menuItems = [
    {
      key: '/app/dashboard',
      icon: <DashboardOutlined />,
      label: <NavLink to="/app/dashboard">Dashboard</NavLink>,
      style: { fontWeight: 500 }
    },
    {
      type: 'divider'
    },
    {
      key: 'learning',
      label: !collapsed && <Text type="secondary" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Learning</Text>,
      type: 'group',
      children: [
        {
          key: '/app/courses',
          icon: <BookOutlined />,
          label: <NavLink to="/app/courses">All Courses</NavLink>
        },
        {
          key: '/app/my-courses',
          icon: <AiFillCustomerService />,
          label: <NavLink to="/app/my-courses">My Courses</NavLink>
        },
        {
          key: '/app/calendar',
          icon: <CalendarOutlined />,
          label: <NavLink to="/app/calendar">Calendar</NavLink>
        }
      ]
    },
    {
      key: 'management',
      label: !collapsed && <Text type="secondary" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Management</Text>,
      type: 'group',
      children: [
        {
          key: '/app/staff',
          icon: <TeamOutlined />,
          label: <NavLink to="/app/staff">All Staff</NavLink>
        },
        {
          key: '/app/articles',
          icon: <FileTextOutlined />,
          label: <NavLink to="/app/articles">Articles</NavLink>
        },
        {
          key: '/app/archives',
          icon: <HddOutlined />,
          label: <NavLink to="/app/archives">Archives</NavLink>
        }
      ]
    },
    {
      key: 'personal',
      label: !collapsed && <Text type="secondary" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Personal</Text>,
      type: 'group',
      children: [
        {
          key: '/app/achievements',
          icon: <StarOutlined />,
          label: <NavLink to="/app/achievements">Achievements</NavLink>
        },
        {
          key: '/app/profile',
          icon: <UserOutlined />,
          label: <NavLink to="/app/profile">Profile</NavLink>
        }
      ]
    }
  ]

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="lg"
      width={260}
      collapsedWidth={80}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        zIndex: 1000,
        boxShadow: '2px 0 8px 0 rgba(29, 35, 41, 0.05)',
        borderRight: '1px solid #f0f0f0'
      }}
      theme="light"
    >
      {/* Logo Section */}
      <div
        style={{ 
          cursor: 'pointer',
          padding: collapsed ? '16px 0' : '20px 24px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          minHeight: '64px'
        }}
      >
        <Logo collapsed={collapsed} />
      </div>

      {/* User Info Section (when not collapsed) */}
      {!collapsed && (
        <div
          style={{
            padding: '20px 24px',
            borderBottom: '1px solid #f0f0f0',
            background: '#fafafa'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Avatar 
              size={40} 
              icon={<UserOutlined />} 
              style={{ backgroundColor: '#1890ff' }}
            />
            <div>
              <Text strong style={{ display: 'block', fontSize: '14px' }}>
                Welcome back!
              </Text>
              {/* <Text type="secondary" style={{ fontSize: '12px' }}>
                Dashboard Overview
              </Text> */}
            </div>
          </div>
        </div>
      )}

      {/* Navigation Menu */}
      <Menu
        mode="inline"
        selectedKeys={[currentPath]}
        style={{
          borderRight: 0,
          background: 'transparent',
          padding: '16px 8px'
        }}
        // items={menuItems}
      >
        <Menu.Item key="/app/dashboard" icon={<DashboardOutlined />}>
          <NavLink to="/app/dashboard">Dashboard</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/courses" icon={<ImBooks />}>
          <NavLink to="/app/courses">All Courses</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/my-courses" icon={<AiFillCustomerService />}>
          <NavLink to="/app/my-courses">My Courses</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/staff" icon={<ImUsers />}>
          <NavLink to="/app/staff">All Staff</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/calendar" icon={<CalendarOutlined />}>
          <NavLink to="/app/calendar">Calendar</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/articles" icon={<RiArticleLine />}>
          <NavLink to="/app/articles">Articles</NavLink>
        </Menu.Item>
        {/* <SubMenu key="sub1" icon={<TeamOutlined />} title="Groups">
          <Menu.Item key="5">Place Holder 1</Menu.Item>
          <Menu.Item key="6">Place Holder 2</Menu.Item>
        </SubMenu> */}
        <Menu.Item key="/app/acheivements" icon={<CrownOutlined />}>
          <NavLink to="/app/acheivements">Acheivements</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/archives" icon={<HddOutlined />}>
          <NavLink to="/app/archives">Archives</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/profile" icon={<UserOutlined />}>
          <NavLink to="/app/profile">Profile</NavLink>
        </Menu.Item>
      </Menu>

      {/* Footer Section */}
      {!collapsed && (
        <div
          style={{
            position: 'absolute',
            bottom: '60px',
            left: '24px',
            right: '24px'
          }}
        >
          <div
            style={{
              padding: '12px 16px',
              background: '#f6f8fa',
              borderRadius: '8px',
              border: '1px solid #e8e8e8'
            }}
          >
            <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>
              Talent Management
            </Text>
            <Text type="secondary" style={{ fontSize: '11px' }}>
              System v2.1
            </Text>
          </div>
        </div>
      )}
    </Sider>
  )
}

export default SideNav